import { HoverText, Icon } from '@advanza/ui'
import { saveProvider } from 'actions/providers'
import EntityComponent from 'components/services/EntityComponent'
import EntityComponentContainer from 'containers/EntityComponentContainer'
import { ChangeEvent } from 'react'

const FIELD = 'bad_response_tickets_disabled'

const failureReason = (response: unknown): string => {
    if (response instanceof Error) {
        return response.message
    }
    if (response && typeof response === 'object' && 'error' in response) {
        return String((response as { error?: unknown }).error)
    }
    return 'unknown error'
}

class BadResponseTicketsSwitch extends EntityComponent {
    editFields = () => ({
        [FIELD]: {
            type: 'boolean',
            disabled: this.getEntity()._saving === true,
            msg: (
                <>
                    No bad response tickets
                    <HoverText
                        trigger={<Icon style={{ marginLeft: 4 }} fontSize={16} name="info" />}>
                        Stops HubSpot from creating a Bad Response ticket when this provider leaves
                        a lead unanswered for 48 hours.
                    </HoverText>
                </>
            ),
        },
    })

    /**
     * EntityComponent keeps the optimistic change when a save is rejected. There is no Save
     * button next to this switch to signal that, so restore the previous value instead of
     * leaving it claiming a suppression the database never stored.
     */
    onChangeAndSave(event: ChangeEvent<HTMLInputElement>) {
        const previous = this.getEntity()[FIELD]

        this.onChange(event)
        this.save().catch((response: unknown) => {
            this.onChangeEntity({ [FIELD]: previous }, { dontTouch: true })
            this.props.addToast({
                msg: `Could not save "no bad response tickets": ${failureReason(response)}`,
                red: true,
                icon: 'error',
            })
        })
    }

    render() {
        return this.renderInput(FIELD, true)
    }
}

export default EntityComponentContainer(BadResponseTicketsSwitch, {
    store: 'providers',
    name: 'providers',
    saveFunc: saveProvider,
})
